export default {
    init() {
      console.log('BLOG');

      // MOVE POPULAR POSTS
      $("#popular-posts").appendTo("#popular-posts-wrapper");

  },
}